import React, { useRef, useState, useEffect } from 'react';

const DoubleVideo = () => {
	const thumbnailVideoRef = useRef(null);
	const fullVideoRef = useRef(null);
	const videoCTARef = useRef(null);
	const FpqUrl = 'https://www.hear.com/d/full_page_questionnaire/';
	const [showFakeButton, setShowFakeButton] = useState(false);
	const [isSafari, setIsSafari] = useState(false);
	const showFakeButtonTime = 3 * 60 + 54; // 3:54

	// Safari/iOS Safari detection - only runs on client side to avoid SSR mismatch
	useEffect(() => {
		const detected =
			/^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
			(/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);

		setIsSafari(detected);
	}, []);

	const handleThumbnailClick = () => {
		const thumbnailVideo = thumbnailVideoRef.current;
		const fullVideo = fullVideoRef.current;

		if (thumbnailVideo && fullVideo) {
			thumbnailVideo.style.display = 'none';
			fullVideo.style.display = 'block';
			fullVideo.play();
		}
	};

	const handleTimeUpdate = () => {
		const fullVideo = fullVideoRef.current;
		if (!fullVideo) return;

		const currentTime = Math.round(fullVideo.currentTime);

		if (currentTime >= showFakeButtonTime && !showFakeButton) {
			setShowFakeButton(true);
		}
	};

	const handleVideoClick = () => {
		const fullVideo = fullVideoRef.current;
		const videoCTA = videoCTARef.current;

		if (showFakeButton && document.fullscreenElement === fullVideo && videoCTA) {
			videoCTA.click();
		}
	};

	const handleFpqRedirect = () => {
		const queryParams = window.location.search;
		window.location.href = FpqUrl + queryParams;
	};

	return (
		<div className="c-relative-double-video o-flush-mobile">
			<video
				ref={thumbnailVideoRef}
				className="c-thumbnail-video o-fluid-img"
				data-src="https://res.cloudinary.com/dhqvlsb3l/video/upload/f_auto,q_auto,vc_auto,w_auto,c_limit/v1/assets/na/video/founders/Founders_thumbnail.mp4"
				poster="https://res.cloudinary.com/dhqvlsb3l/image/upload/f_auto,fl_lossy,q_auto:eco,w_auto,dpr_auto/v1/assets/na/video/founders/Founders_thumbnail_image.jpg"
				autoPlay
				loop
				playsInline
				muted
				onClick={handleThumbnailClick}
			/>

			<video
				ref={fullVideoRef}
				className="c-full-video o-fluid-img"
				src="https://res.cloudinary.com/dhqvlsb3l/video/upload/f_auto,q_auto,vc_auto,w_auto,c_limit/v1/assets/na/video/founders/Founders_optimized.mp4"
				poster="https://res.cloudinary.com/dhqvlsb3l/image/upload/f_auto,fl_lossy,q_auto:eco,w_auto,dpr_auto/v1/assets/na/video/founders/Founders_still1.jpg"
				playsInline
				controls
				controlsList="nodownload noremoteplayback"
				onTimeUpdate={handleTimeUpdate}
				onClick={handleVideoClick}
			/>

			<button
				ref={videoCTARef}
				className={`c-video-cta ${isSafari ? 'c-video-cta--safari' : ''}`}
				style={{ display: showFakeButton ? 'block' : 'none' }}
				aria-label="Start questionnaire"
				onClick={handleFpqRedirect}
			/>
		</div>
	);
};

export default DoubleVideo;
